import { useContext, useEffect } from 'react'
import { FormContext } from './form-provider'
import type { GenericFormType } from './types'

// Define the props for the FormMounter component
type FormMounterProps = {
  id: string
  form: GenericFormType<unknown>
}

// FormMounter component to handle form registration and cleanup
export const FormMounter = ({ id, form }: FormMounterProps) => {
  // Access the FormContext
  const context = useContext(FormContext)

  useEffect(() => {
    // If an id is provided, register the form and set up cleanup
    if (id) {
      // Add the form to the context
      context?.addForm(id, form)
      // Return a cleanup function to remove the form when the component unmounts
      return () => context?.removeForm(id)
    }
    return undefined
  }, []) // Empty dependency array ensures this effect runs only once on mount

  // This component doesn't render anything
  return null
}
